// src/api/axiosInstance.js
import axios from "axios";
import generateSignature from "../utils/signatureUtils";
import { setCookie } from "../utils/setCookie";

// 创建axios实例
const api = axios.create({
  baseURL: "https://api.club.kdslife.com", // 你的API基础URL
  headers: {
    "Content-Type": "multipart/form-data",
  },
  // timeout: 10000, // 请求超时时间（10秒）
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // const token = localStorage.getItem('authToken'); // 从本地存储中获取Token
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`; // 添加认证信息
    // }
    if (
      config.method === "post" ||
      config.method === "put" ||
      config.method === "patch"
    ) {
      if (config.data) {
        // 假设 config.data 是一个对象
        const sign = generateSignature(config.data); // 调用加密函数
        // 将原始数据和签名一起放入 body
        config.data = {
          ...config.data,
          sign, // 添加签名到请求体
        };
      }
    }

    // 你可以在这里添加其他请求头或修改请求参数
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    // 对响应数据做些什么

    // 将对象格式 {'0': item1, '1': item2, ...} 转换回数组
    if (
      response.data &&
      response.data.data &&
      typeof response.data.data === "object"
    ) {
      // 遍历 data 的所有属性
      Object.keys(response.data.data).forEach((key) => {
        const value = response.data.data[key];
        // 检查属性值是否是对象且键只有数字
        if (value && typeof value === "object" && !Array.isArray(value)) {
          const subKeys = Object.keys(value);
          if (
            subKeys.length > 0 &&
            subKeys.every((subKey) => !isNaN(parseInt(subKey)))
          ) {
            // 将对象转换为数组
            response.data.data[key] = Object.values(value);
          }
        }
      });
    }

    if (response.data.msg === "登录后有值") {
      // 清除 sid cookie，确保指定正确的路径和域
      setCookie("sid", "", -1);

      // 可以添加重定向到登录页面的逻辑

      // console.log(getCookie("sid"));
    }
    return response;
  },
  (error) => {
    // 对响应错误做些什么
    const { response } = error;

    if (response) {
      // 服务器返回了状态码，但不是2xx
      switch (response.status) {
        case 401:
          // 处理未授权的响应（如跳转到登录页面）
          console.warn("Unauthorized: Please log in again.");
          // 你可以在这里触发重定向到登录页面
          // window.location.href = '/login';
          break;
        case 403:
          // 处理禁止访问的响应
          console.warn(
            "Forbidden: You do not have permission to access this resource."
          );
          break;
        case 404:
          // 处理资源未找到的响应
          console.warn("Not Found: The requested resource could not be found.");
          break;
        case 500:
          // 处理服务器内部错误
          console.error("Internal Server Error:", response.data);
          break;
        default:
          console.error("Request failed with status code:", response.status);
      }
    } else {
      // 请求被取消、网络错误或其他情况
      console.error("Request failed:", error.message);
    }

    return Promise.reject(error); // 返回一个拒绝的Promise，以便调用者可以捕获错误
  }
);

export default api;
